import request from "@/utils/request_cn";

export async function fileUpload() {
  return (await request({
    url: `/oss/file-upload-auth-sts`,
    method: 'GET'
  })).data;
}
export async function getTemplateUrl(url) {
  return (
    await request({
      url,
      method: "get",
      responseType: "blob",
    })
  ).data;
}

export async function analyzeFile(url, data) {
  return (await request({
    url,
    method: 'post',
    data
  })).data;
}
export async function analyzeResult(url, params) {
  return (
    await request({
      url,
      method: "get",
      params,
    })
  ).data;
}
export async function submitFile(url, data) {
  return (await request({
    url,
    method: 'post',
    data
  })).data;
}
